export const TYPES = {
  RestrictionsService: Symbol('RestrictionsService'),
  RestrictionsRepository: Symbol('RestrictionsRepository'),
  RestrictionsFacade: Symbol('RestrictionsFacade'),
  RestrictionsStore: Symbol('RestrictionsStore'),
};
